module.exports = __webpack_public_path__ + "media/dogs/dog-in-hearts-a7221f19.svg";